import UnavailableTypesModel from '../models/UnavailableTypesModel';

export default class UnavailableTypesCollection extends Backbone.Collection {
  constructor(options) {
    super(options);

    this.model = UnavailableTypesModel;
  }

  url() {
    return UnavailableTypesCollection.url();
  }

  static url() {
    return (
      appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
      + appConstants.ApiPaths.API_VERSION_PATH
      + appConstants.EndPoints.UNAVAILABLE_TYPES_PATH
    );
  }

  parse(data) {
    return null;
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;

    switch (actionType) {
      case ActionTypes.GET_UNAVAILABLE_TYPES:
        Utils.setMakeshiftTokenHeader();
        UnavailableTypesStore.fetch({
          url: UnavailableTypesCollection.url(),
          type: 'GET',
          data: payload.postData,
          success: UnavailableTypesStore.onUnavailablesHandler,
          fail: UnavailableTypesStore.onUnavailablesError,
        });
        break;
      default:
        break;
    }
  }
}
